import { format } from 'date-fns';
import { ja } from 'date-fns/locale';

export function formatYYYYMMDD(date) {
  if (date) {
    return format(new Date(date), 'yyyy年MM月dd日', { locale: ja });
  }

  return '';
}

export function formatMonthDay(date) {
  if (date) {
    return format(new Date(date), 'M/d', { locale: ja });
  }

  return '';
}

export function formatYearMonth(date) {
  if (date) {
    return format(new Date(date), 'yyyy-MM', { locale: ja });
  }

  return '';
}

export function formatDate(date) {
  if (date) {
    return format(new Date(date), 'yyyy-MM-dd', { locale: ja });
  }

  return '';
}

export function formatDateTime(date) {
  if (date) {
    return format(new Date(date), 'yyyy-MM-dd HH:mm:ss', { locale: ja });
  }

  return '';
}

export function formatDateTimeWithoutSeconds(date) {
  if (date) {
    return format(new Date(date), 'yyyy-MM-dd HH:mm', { locale: ja });
  }

  return '';
}

export function formatMonthDayHourMinute(date) {
  if (date) {
    return format(new Date(date), 'M/d HH:mm', { locale: ja });
  }

  return '';
}
